export default __webpack_public_path__ + "static/media/lato-bolditalic.da75a878.svg";